// extracted by mini-css-extract-plugin
export var contactItem = "contact-item-module--contact-item--Pmzgp";
export var contactItemIcon = "contact-item-module--contact-item-icon--IBQWb";
export var contactItemSectionInfo = "contact-item-module--contact-item-section-info---6I4H";
export var contactItemSectionTitle = "contact-item-module--contact-item-section-title--xeP9e";